export class DecoderHelpers {
  
  static updateBitMeaning = (byteIndex, bitPosition, newValue, matrixData, builderData, templateConfig, currentHexValue) => {
    const byteKey = `byte${byteIndex}`;
    
    if (!builderData) {
      const currentRow = matrixData[byteKey]?.rows?.find(row => row.bit === bitPosition);
      return currentRow?.meaning || '';
    }

    if (templateConfig.pageKey === 'cvmResults') {
      if (byteIndex === 1 && bitPosition === 7) {
        const staticTexts = builderData.staticTexts;
        return newValue 
          ? staticTexts?.bit7When1 || "Apply succeeding CV Rule if this CVM is unsuccessful"
          : staticTexts?.bit7When0 || "Fail cardholder verification if this CVM is unsuccessful";
      }

      if (byteIndex === 1 && bitPosition >= 1 && bitPosition <= 6) {
        const hexValue = currentHexValue.padStart(templateConfig.fieldConfig.validation.min, '0');
        const byte1Value = parseInt(hexValue.substring(0, 2), 16);
        
        const methodBits = [];
        for (let bit = 6; bit >= 1; bit--) {
          methodBits.push((byte1Value >> (bit - 1)) & 1);
        }
        const binaryString = methodBits.join('');
        
        const methodMap = builderData.method?.map || [];
        const foundMethod = methodMap.find(item => item.codeBits === binaryString);
        
        return foundMethod
          ? ` ${foundMethod.label}`
          : ` ${builderData.method?.defaultLabel || 'Unknown'}`;
      }

      if (byteIndex === 1 && bitPosition === 0) {
        const hexValue = currentHexValue.padStart(templateConfig.fieldConfig.validation.min, '0');
        const byte1Value = parseInt(hexValue.substring(0, 2), 16);
        
        const methodBits = [];
        for (let bit = 6; bit >= 1; bit--) {
          methodBits.push((byte1Value >> (bit - 1)) & 1);
        }
        const binaryString = methodBits.join('');
        
        const methodMap = builderData.method?.map || [];
        const foundMethod = methodMap.find(item => item.codeBits === binaryString);
        
        return foundMethod
          ? ` ${foundMethod.label}`
          : ` ${builderData.method?.defaultLabel || 'Unknown'}`;
      }
    }

    if (templateConfig.pageKey === 'tvr') {
      if (byteIndex === 5 && (bitPosition === 1 || bitPosition === 2)) {
        const hexValue = currentHexValue.padStart(templateConfig.fieldConfig.validation.min, '0');
        const byte5Value = parseInt(hexValue.substring(8, 10), 16);
        
        const bit2Value = (byte5Value >> 1) & 1;
        const bit1Value = byte5Value & 1;
        const combinedKey = bit2Value.toString() + bit1Value.toString();
        
        const combinedMap = builderData.byte5CombinedMap || [];
        const foundMapping = combinedMap.find(item => item.key === combinedKey);
        return foundMapping 
          ? `${combinedKey} = ${foundMapping.label}`
          : `${combinedKey} = ${builderData.defaultLabel || 'Unrecognized'}`;
      }

      if (byteIndex === 5 && bitPosition === 0) {
        const hexValue = currentHexValue.padStart(templateConfig.fieldConfig.validation.min, '0');
        const byte5Value = parseInt(hexValue.substring(8, 10), 16);
        
        const bit2Value = (byte5Value >> 1) & 1;
        const bit1Value = byte5Value & 1;
        const combinedKey = bit2Value.toString() + bit1Value.toString();
        
        const combinedMap = builderData.byte5CombinedMap || [];
        const foundMapping = combinedMap.find(item => item.key === combinedKey);
        return foundMapping 
          ? `${combinedKey} = ${foundMapping.label}`
          : `${combinedKey} = ${builderData.defaultLabel || 'Unrecognized'}`;
      }
    }

    if (templateConfig.pageKey === 'ctq') {
      if (byteIndex === 1 && bitPosition === 1) {
        let updatedMeaning = currentRow?.meaning || '';
        
        const isContactlessAtmPattern = /contactless ATM transactions/i.test(updatedMeaning);
        
        if (isContactlessAtmPattern) {
          if (newValue) {
            if (!updatedMeaning.toLowerCase().includes('not')) {
              updatedMeaning = updatedMeaning.replace(/(valid for contactless ATM transactions)/i, 'Not valid for contactless ATM transactions');
            }
          } else {
            updatedMeaning = updatedMeaning.replace(/not\s+/i, '');
          }
        }
        
        return updatedMeaning;
      }
    }

    const currentRow = matrixData[byteKey]?.rows?.find(row => row.bit === bitPosition);
    return currentRow?.meaning || '';
  }

  static isPlaceholderBit = (byteIndex, bitPosition, templateConfig) => {
    if (templateConfig.pageKey === 'cvmResults') {
      return (byteIndex === 1 && (bitPosition === 7 || bitPosition === 0));
    }
    
    if (templateConfig.pageKey === 'tvr') {
      return (byteIndex === 5 && bitPosition === 0);
    }
    
    return false;
  }

  static handleBitToggle = (byteIndex, bitPosition, currentValue, currentHexValue, fieldConfig) => {
    const hexValue = currentHexValue.padStart(fieldConfig.validation.min, '0')
    
    const bytes = [];
    for (let i = 0; i < hexValue.length; i += 2) {
      bytes.push(parseInt(hexValue.substring(i, i + 2), 16));
    }
    
    const targetByteIndex = byteIndex - 1; 
    let newByte = bytes[targetByteIndex];
    
    if (currentValue) {
      newByte = newByte & ~(1 << (bitPosition - 1));
    } else {
      newByte = newByte | (1 << (bitPosition - 1));
    }
    
    bytes[targetByteIndex] = newByte;
    
    const newHexValue = bytes.map(byte => 
      byte.toString(16).padStart(2, '0').toUpperCase()
    ).join('');
    
    return newHexValue;
  }

  static updateFormField = (newHexValue) => {
    const form = document.querySelector('form');
    const dataField = form.querySelector(`input[name="data"]`);
    if (dataField) {
      dataField.value = newHexValue;
      dataField.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
